export default __webpack_public_path__ + "static/media/search.d8cfb21f.svg";